import { WSIcons } from "../../commonFunctions/iIcons";

export const getMenu: any = (userType: string) => {
  return {
    staticMenu:
      userType === "admin"
        ? [
          {
            id: 1,
            label: "Home",
            icon: WSIcons.Home,
            path: "/home"
          },
          {
            id: 2,
            label: "Masters",
            icon: WSIcons.Masters,
            children: [
              {
                id: 3,
                label: "Banner",
                path: "/banner/list"
              },
              {
                id: 4,
                label: "Designations",
                path: "/designations"
              },

            ]
          },

          {
            id: 9,
            label: "Products",
            icon: WSIcons.PersonOffIcon,
            children: [
              {
                id: 9,
                label: "Product List",
                path: "/product/list"
              },
              {
                id: 10,
                label: "Wish List",
                path: "/wish/list"
              }
            ]
          },

          {
            id: 13,
            label: "Settings",
            icon: WSIcons.SettingsIcon,
            children: [
              {
                id: 14,
                label: "Organization",
                path: "/organization/view"
              },
              {
                id: 15,
                label: "Change Password",
                path: "/changepassword"
              }
            ]
          }
        ]
        : [
          {
            id: 3,
            label: "Home",
            icon: WSIcons.OverViewIcon,
            path: "/invoice-page"
          },
          // {
          //   id: 1,
          //   label: "Home",
          //   icon: WSIcons.Home,
          //   path: "/vendor-product/list"
          // },

          {
            id: 2,
            label: "Parties",
            icon: WSIcons.AllInclusiveOutlinedIcon,
            children: [
              {
                id: 21,
                label: "Party Details",
                path: "/add-party"
              },
             
             

            ]
          },
          
            {
            id: 8,
            label: "Unit",
            icon: WSIcons.OverViewIcon,
            path: "/select-unit/list"
          },
           {
            id: 9,
            label: "Services",
            icon: WSIcons.OverViewIcon,
            path: "/item-service"
          },
             {
            id: 10,
            label: "Category",
            icon: WSIcons.OverViewIcon,
            path: "/category/list"
          },
             {
            id: 11,
            label: "Business Details",
            icon: WSIcons.OverViewIcon,
            path: "/business-details"
          },
             {
            id: 12,
            label: "Company",
            icon: WSIcons.OverViewIcon,
            path: "/company/list"
          },
           {
            id: 13,
            label: "Purchase & Expense",
            icon: WSIcons.SettingsIcon,
            children: [
                {
            id: 14,
            label: "Purchase",
            icon: WSIcons.OverViewIcon,
            path: "/purchase"
          },
           {
            id: 15,
            label: "Payment Out",
            icon: WSIcons.OverViewIcon,
            path: "/payment-out/list"
          },
           {
            id: 16,
            label: "Expense",
            icon: WSIcons.OverViewIcon,
            path: "/expense"
          },
          {
            id: 17,
            label: "Purchase Order",
            icon: WSIcons.OverViewIcon,
            path: "/purchase-order"
          },
          
           {
            id: 19,
            label: "Debit",
            icon: WSIcons.OverViewIcon,
            path: "/debit-note"
          },
            ]
          },
          
               {
            id: 2,
            label: "Cash & Bank",
            icon: WSIcons.AllInclusiveOutlinedIcon,
            children: [
              {
                id: 21,
                label: "Bank Accounts",
                path: "/Bank-account/create"
              },
              {
                id: 22,
                label: "Cash In Hand",
                path: "/cash-in-hand/list"
              },
              {
                id: 22,
                label: "Loan Accounts",
                path: "/loan-account/list"
              },

            ]
          },
           {
            id: 23,
            label: "Users",
            icon: WSIcons.OverViewIcon,
            path: "/user/list"
          },
            {
            id: 6,
            label: "Settings",
            icon: WSIcons.SettingsIcon,
            children: [
              {
                id: 22,
                label: "General",
                path: "/settings/general"
              },
              {
                id: 23,
                label: "Transactions",
                path: "/settings/transaction"
              },
              {
                id: 24,
                label: "Taxes & GST",
                path: "/settings/tax-gst"
              },
             {
                id: 25,
                label: "Party",
                path: "/settings/party"
              },
               {
                id: 26,
                label: "Items",
                path: "/settings/items"
              },
                {
                id: 27,
                label: "Accounting ",
                path: "/settings/accounting"
              },
              {
                id: 37,
                label: "Transaction Message",
                path: "/settings/transactionmessage"
              },
            ]
          },
           
            {
            id: 4,
            label: "Sale",
            icon: WSIcons.SettingsIcon,
            children: [
              {
                id: 28,
                label: "Sale Invoices",
                path: "/add/sale"
              },
                {
                id: 29,
                label: "Estimate/Quatation",
                path: "/add/estimate"
              },
                {
                id: 30,
                label: "Proforma Invoice",
                path: "/add/proforma"
              },
                 {
                id: 31,
                label: "Sale Order",
                path: "/add/sale-order"
              },
                 {
                id: 32,
                label: "Payment In",
                path: "/add/payment-in"
              },
              {
                id: 33,
                label: "Delivery Challan",
                path: "/add/delivery-challan"
              },
                  {
                id: 34,
                label: "Sale Return/Credit Note",
                path: "/add/credit-note"
              },
                  {
                id: 35,
                label: "Other Income",
                path: "/add/other-income"
              },
                   {
                id: 36,
                label: "Vyapar POS",
                path: "/add/vyapar-pos"
              },
               
            ]
          },
           {
            id: 37,
            label: "Other Products",
            icon: WSIcons.OverViewIcon,
            path: "/products"
          },
          
//             id: 6,
//             label: "Payments",
//             icon: WSIcons.PaymentsIcon,
//             children: [
              

//             ]
//           },
          
//  {
//             id: 8,
//             label: "Announcements",
//             icon: WSIcons.CampaignIcon,
//            path:"/announcements"
//           },
// {
//             id: 9,
//             label: "Reports",
//             icon: WSIcons.reportIcon,
//             children: [
              

//             ]
//           },
//           {
//             id: 10,
//             label: "Support",
//             icon: WSIcons.SupportIcon,
//             children: [
              

//             ]
//           },
        ]
  };
};
